var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"clipped":"","app":"","touchless":"","disable-resize-watcher":"","width":"400","value":_vm.hide,"mobile-breakpoint":0}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }